import VFLottieView from './VFLottieView';
import { LottieTypes } from './VFLottieView.Enums';

export default VFLottieView;
export { LottieTypes };
